import Link from 'next/link'
import WrapperAlt from '@components/image/WrapperAlt'
import BlogImage from '@components/blog/components/BlogImage'
import Icon from '@components/shared/Icon'
import { postLink, postImage } from '@components/blog/utils/postLinks'
import useT from '@hooks/useTranslation'

import styles from '../styles/BlogSample.module.css'

export default function ({ articles }) {
    if (!Array.isArray(articles) || !articles.length) return null

    return <div className="container">
        <div className={styles.sample}>
            { articles.map(article => <Article key={article.slug} article={article} />) }
        </div>
    </div>
}

function Article ({ article }) {
    const link = postLink(article)
    const image = postImage(article)
    const { title, imgAlt, imgTitle, shortDesc } = article

    const wiecej = useT('Wiecej')

    return (
        <article>
            <header>
                <Link href={link}>
                    <a>
                        <WrapperAlt>
                            <BlogImage
                                alt={imgAlt||title}
                                breakpoint={null}
                                src={image}
                                title={imgTitle||title} />
                        </WrapperAlt>
                    </a>
                </Link>
                <Link href={link}>
                    <a><h2>{title}</h2></a>
                </Link>
            </header>
            <div>
                <p>{shortDesc}...</p>
                <Link href={link}>
                    <a className={styles.link}>{wiecej} <Icon>keyboard_double_arrow_right</Icon></a>
                </Link>
            </div>
        </article>
    )
}